import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/constants/links";

const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="floating-whatsapp-btn"
    className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-200 hover:scale-105 md:hidden"
  >
    <MessageCircle className="h-6 w-6" />
  </a>
);

export default FloatingWhatsApp;
